import React from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Promo = () => {
    const history = useHistory();

    const handlePick = () => {
        history.push("/popstars");
    };
    return (
        <Card>
            <Card.Body>
                <Row className="justify-content-center mb-3">
                    <Col xs="auto" className="titles">
                        Has acumulado 50 puntos
                    </Col>
                    <Col xs="auto">
                        <button
                            className="button-text mt-3 mt-md-0 "
                            onClick={handlePick}
                        >
                            Mas info
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col className="textBod">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Puntos</th>
                                    <th>Recompensa</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>100</td>
                                    <td>Peluche</td>
                                </tr>
                                <tr>
                                    <td>120</td>
                                    <td>Tenis</td>
                                </tr>
                                <tr>
                                    <td>150</td>
                                    <td>Chamarra</td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default Promo;
